/** UI wizard content type → persisted `Good.contentType` / `GoodVersion.contentType`. */
export function resolveWizardGoodStorageContentType(
  contentType: "photo" | "card" | "video" | null | undefined,
  fallback?: "card" | "images" | "video"
): "card" | "images" | "video" {
  if (contentType === "photo") return "images";
  if (contentType === "video") return "video";
  if (contentType === "card") return "card";
  return fallback ?? "card";
}

/** UI wizard content type → Content Jobs API `contentType`. */
export function resolveWizardContentJobContentType(
  contentType: "photo" | "card" | "video" | null | undefined
): "photo" | "card" {
  return contentType === "photo" ? "photo" : "card";
}
